// extracted by mini-css-extract-plugin
export var connectionButton = "_5s-1";
export var rightPanel = "_5s-3";
export var stepDescription = "_5s-2";
export var stepIcon = "_5s-0";